import React, { useState, useEffect } from 'react';
import './reportviewer.css';
import PDFViewer from 'pdf-viewer-reactjs'
import ReactSwitch from 'react-switch';
import * as apiClient from "../../../common/apiClient";
const ReportViewer = (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isShare, setIsShare] = useState(false);
    const [pdfFiles, setPdfFiles] = useState(props.files);
    const [selectedFile, setSelectedFile] = useState(pdfFiles.length > 0 ? pdfFiles[0].reportUrl : '');
    const [loading, setLoading] = useState(true)
    const [sendInvoice, setSendInvoice] = useState(false);
    const [emails, setEmails] = useState(null);
    const [validationMessage, setValidationMessage] = useState('');
    const [isSharing, setIsSharing] = useState(false)
    const [showReportSharedMessage, setShowReportSharedMessage] = useState(false);


    useEffect(() => {
        if (pdfFiles.length > 0) {
            setSelectedFile(pdfFiles[0].reportUrl);
            setTimeout(() => {
                setLoading(false); // Set loading to false after 1 second
            }, 1000);
        }
    }, [pdfFiles]);

    const closeModal = () => {
        props.close();
        setModalIsOpen(false);
    };
    
    const handleShare = () => {
        debugger

        if(!emails)
        {
            setValidationMessage('Please enter at least one email.');
            return;
        }
        
        const invalidEmailsArray = [];

        const emailArray = emails.split(',').map(email => email.trim());
        emailArray.forEach(email => {
                if (!apiClient.validateEmail(email)) {
                        invalidEmailsArray.push(email);
                    } 
                });
        if(invalidEmailsArray.length>0)
        {
            setValidationMessage('Please enter valid email.');
            return;
            
        }
        setValidationMessage(null);
        setIsSharing(true);
        
        let payload={
            requestId: pdfFiles[0].requestId,
            email:  emails,
            sendInvoice:sendInvoice
          }
          
            apiClient.post('requests/emailreports', payload,null).then((response) => {
            if (response) {
              if(response.result)
              {
                setShowReportSharedMessage(response.message)
                setIsShare(false)
                setEmails(null);
                setSendInvoice(false)
              }
              else
              {
                setValidationMessage(response.message)
              }
              setIsSharing(false);
            }
            //setLoadingReportId(null);
          }).catch((err) => {
            setIsSharing(false);
          })
        
        

    };

    const handleTileClick = (url, index) => {
        setSelectedFile(null);
        setSelectedFile(url);
        setSelectedIndex(index);
    };

    return (
        <div>
            {modalIsOpen && (
                <div className="custom-modal-overlay">
                    <div className="app">
                        <div className="close-button" onClick={closeModal}>
                            &times;
                        </div>
                        <div className="left-section">
                            <div className='reportHeader'>Report</div>
                            <div className="tiles">
                                {pdfFiles.map((file, index) => (
                                    <div
                                        key={file.id}
                                        className={`tile ${selectedIndex === index ? 'selected' : ''}`}
                                        onClick={() => handleTileClick(file.reportUrl, index)}
                                    >
                                        {file.report_type}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {pdfFiles && pdfFiles.length>0 && (
                            <div className="center-right-section">
                                <div className="emailsection">
                                    {isShare && <div className="inputsection">
                                        <input className='emailInput' type='text' value={emails} placeholder='Please enter multiple emails, separated by commas.' onChange={(event) => { setEmails(event.target.value) }} />
                                        <div style={{ display: 'flex' }}>
                                            <h4 style={{ marginTop: 8, marginRight: 10 }} >Include Invoice</h4>
                                            <ReactSwitch checked={sendInvoice} onChange={(val) => setSendInvoice(val)} aria-label='Include Invoice' onColor="#1e90ff" offColor="#333" />
                                        </div>
                                    </div>
                                    }
                                    <div className="buttonsection">
                                        {!isShare && (
                                            <div className="sharebutton" onClick={() => {setIsShare(true);setShowReportSharedMessage(null);setValidationMessage(null)}}>
                                                Share Reports
                                            </div>
                                        )}
                                        {isShare && (
                                            <>
                                                <div className={`sharebutton ${isSharing ? 'loading' : ''}`} onClick={!isSharing?handleShare:null}>
                                                    {isSharing ? <div className="loading-spinner"></div> : 'Share'}
                                                </div> 
                                                {!isSharing && <div className="sharebutton" onClick={() => setIsShare(false)}>
                                                    Cancel
                                                </div>}
                                            </>
                                        )}
                                    </div>

                                    {/* <div className="buttonsection">

                                        {!isShare && <div className='sharebutton' onClick={() => { setIsShare(true) }} >Share Reports</div>}
                                        {isShare && <div className='sharebutton' onClick={handleShare} >Share </div>}
                                        {isShare && <div className='sharebutton' onClick={() => { setIsShare(false);setValidationMessage(null) }} >Cancel</div>}
                                    </div> */}


                                </div>
                                {validationMessage && (
                                    <div style={{ color: 'red', marginTop: 1, fontSize: 18, textAlign: 'center' }}>{validationMessage}</div>
                                )}
                                {showReportSharedMessage && (
                                    <div style={{ color: 'green', marginTop: 1, fontSize: 18, textAlign: 'center' }}>{showReportSharedMessage}</div>
                                )}
                                {!loading && selectedFile != null && <iframe
                                    title="PDF Viewer"
                                    //  src={`https://docs.google.com/gview?url=${selectedFile}&embedded=true`}
                                    src={selectedFile}
                                    style={{ outline: 'none', border: '1px solid lightgrey' }}
                                    width="100%"
                                    height="80%"
                                ></iframe>
                                }

                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReportViewer;
